import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/fiverr_context';
import { HEADER_NAV_SOURCE } from '../../../../constants';
import Link from '../../../Links/Link';

const HelpCenterLink = () => (
    <Link
        href={pathfinder('help_center_homepage', null, { query: { source: HEADER_NAV_SOURCE } })}
        target="_blank"
        rel="noopener noreferrer"
        className="nav-link"
    >
        <I18n k="header.link_label.help_center" />
    </Link>
);

export default HelpCenterLink;
